import Home from '@/pages/Home.vue';
import { permissions } from '@/utils/permissions/permission.model';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import AuthGuard from './guards/auth.guard';
import DivisionGuard from './guards/division.guard';
import GuestGuard from './guards/guest.guard';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/pages/Auth/Login.vue'),
    meta: { requiresNotLogin: true }
  },
  {
    path: '/user/create',
    name: 'user/create',
    component: () => import('@/pages/Auth/CreateUser.vue'),
    meta: { permission: permissions.user.create }
  },
  {
    path: '/wo/import/:type',
    name: 'workOrder',
    component: () => import('@/pages/Import/ImportCreate/ImportCreate.vue')
  },
  {
    path: '/main/:type',
    name: 'main',
    component: () => import('@/pages/Main/MainPage.vue')
  },
  {
    path: '/reports/:type',
    name: 'reports',
    component: () => import('@/pages/Reports/Reports.vue')
  },
  {
    path: '/master',
    component: () => import('@/pages/Master/MasterPage.vue'),
    children: [
      {
        path: '/master/driver',
        name: 'master-driver',
        component: () => import('@/pages/Master/Driver/Driver.vue')
      },
      {
        path: '/master/company',
        name: 'company',
        component: () => import('@/pages/Master/Company/Company.vue')
      },
      {
        path: '/master/account-code',
        name: 'account-code',
        component: () => import('@/pages/Master/Account/Account.vue')
      }
    ]
  },
  {
    path: '/dispatch/export/booking',
    name: 'export-booking',
    component: () => import('@/pages/Dispatch/Export/Booking/Booking.vue')
  },
  {
    path: '/dispatch/export/return',
    name: 'export-return',
    component: () => import('@/pages/Dispatch/Export/Return/Return.vue')
  },
  {
    path: '/dispatch/export/delivery',
    name: 'export-delivery',
    component: () => import('@/pages/Dispatch/Export/Delivery/Delivery.vue')
  },
  {
    path: '/dispatch/export/unavailable',
    name: 'export-unavailable',
    component: () =>
      import('@/pages/Dispatch/Export/Unavailable/Unavailable.vue')
  },
  {
    path: '/dispatch/export/available',
    name: 'export-available',
    component: () => import('@/pages/Dispatch/Export/Available/Available.vue')
  },
  {
    path: '/dispatch/van/:type',
    name: 'van',
    component: () => import('@/pages/Dispatch/Van/Van.vue')
  },
  {
    path: '/dispatch/import/:type',
    name: 'import',
    component: () => import('@/pages/Dispatch/Import/Import.vue')
  },
  {
    path: '/acct/:type',
    name: 'accounting',
    component: () => import('@/pages/Accounting/Accounting.vue')
  },
  {
    path: '/yms/inventory',
    name: 'inventory',
    meta: { subPage: 'yms' },
    component: () => import('@/pages/YMS/Inventory/Inventory.vue')
  },
  {
    path: '/yms/daily-in-out',
    name: 'daily-in-out',
    meta: { subPage: 'yms' },
    component: () => import('@/pages/YMS/DailyInOut/DailyInOut.vue')
  },
  {
    path: '/yms/damage-report',
    name: 'damage',
    meta: { subPage: 'yms' },
    component: () => import('@/pages/YMS/DamageReport/DamageReport.vue')
  },
  {
    path: '/yms/nav-trac',
    name: 'yms/nav-trac',
    meta: { subPage: 'yms' },
    component: () => import('@/pages/YMS/NavTrac/NavTrac.vue')
  },
  {
    path: '/driver/:type',
    name: 'driver',
    component: () => import('@/pages/Driver/Driver.vue')
  },
  {
    path: '/edi/hd',
    name: 'edi/hd',
    component: () => import('@/pages/EDI/HD/HD.vue')
  },
  {
    path: '/edi/eg',
    name: 'edi/eg',
    component: () => import('@/pages/EDI/EG/EG.vue')
  },
  {
    path: '/admin/early-warning',
    name: 'admin/early-warning',
    component: () => import('@/pages/Admin/EarlyWarning/EarlyWarning.vue')
  },
  {
    path: '/admin/roles',
    name: 'admin/roles',
    component: () => import('@/pages/Admin/UserRoles/UserRoles.vue')
  },
  {
    path: '/admin/config',
    name: 'admin/config',
    component: () => import('@/pages/Admin/Configuration/Configuration.vue')
  },
  {
    path: '/admin/early-warning-modal',
    name: 'early-warning-modal',
    component: () => import('@/shared/components/modal/EarlyWarningModal.vue'),
    meta: { hideHeader: true }
  },
  {
    path: '/admin/user-managment',
    name: 'admin/user-management',
    component: () => import('@/pages/Admin/UserManagement/UserManagement.vue')
  },
  {
    path: '/map',
    component: () => import('@/pages/Map/MapPage.vue'),
    children: [
      {
        path: 'map',
        name: 'Map',
        component: () => import('@/pages/Map/Components/ClassicMap.vue')
      },
      {
        path: 'geofence',
        name: 'Geofence',
        component: () => import('@/pages/Map/Components/Geofence.vue')
      }
    ]
  },
  {
    path: '*',
    component: () => import('@/pages/NotFound/NotFoundPage.vue')
  }
];

const router = new VueRouter({
  routes
});

router.beforeResolve(GuestGuard);
router.beforeResolve(AuthGuard);
router.beforeResolve(DivisionGuard);

export default router;
